import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IApprovedProduct,
  IApprovedProductsParams,
  IApprovedProductsResponse,
} from '@/services/standalone/approvedProducts';

export interface ApprovedProductsState {
  approvedProducts: IApprovedProductsResponse;
  loading: boolean;
  error: boolean;
  message: string;
  shouldRefetchApprovedProducts: boolean;
}

export const initialState: ApprovedProductsState = {
  loading: false,
  error: false,
  message: '',
  shouldRefetchApprovedProducts: false,
  approvedProducts: {
    success: false,
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
    },
    message: '',
  },
};

const approvedProductsSlice = createSlice({
  name: 'approvedProducts',
  initialState,
  reducers: {
    fetchApprovedProducts: (state, _action: PayloadAction<IApprovedProductsParams | undefined>) => {
      state.loading = true;
      state.error = false;
      state.message = '';
      state.shouldRefetchApprovedProducts = false;
    },
    fetchApprovedProductsSuccess: (state, action: PayloadAction<IApprovedProductsResponse>) => {
      state.loading = false;
      state.approvedProducts = action.payload;
      state.error = false;
    },
    fetchApprovedProductsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = true;
      state.message = action.payload;
    },
    clearApprovedProducts: (state) => {
      state.approvedProducts = initialState.approvedProducts;
      state.loading = false;
      state.error = false;
      state.message = '';
    },
    setShouldRefetchApprovedProducts: (state, action: PayloadAction<boolean>) => {
      state.shouldRefetchApprovedProducts = action.payload;
    },
  },
});

export const {
  fetchApprovedProducts,
  fetchApprovedProductsSuccess,
  fetchApprovedProductsFailure,
  clearApprovedProducts,
  setShouldRefetchApprovedProducts,
} = approvedProductsSlice.actions;

export default approvedProductsSlice.reducer;
